module.exports = __webpack_public_path__ + "img/logo-dark.01ef3ce5.png";